/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import {
  Grid,
  Box,
  Button,
  Autocomplete,
  TextField,
  Card,
  CardContent,
  Divider,
  Typography,
} from '@mui/material';
import { PDFDownloadLink } from '@react-pdf/renderer';
import NumberFormat from '../../utils/NumberFormat';
import { ContainerPainel, Title, SubTitle } from '../../styles/GlobalStyles';
import Loading from '../../components/Loading';
import axios from '../../services/axios';
import * as colors from '../../config/colors';
import { roundToTwoDecimal } from '../../utils/numberUtils';
import PDFContent from './PDFContent';
import styles from './styled';
import * as actions from '../../store/modules/auth/actions';

dayjs.locale('pt-br');

export default function DashMapaProducao() {
  const dispatch = useDispatch();
  const [motoristas, setMotoristas] = useState([]);
  const [veiculos, setVeiculos] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [viagens, setViagens] = useState([]);
  const [qtde, setQtde] = useState([]);
  const [semViagens, setVeiculosSemViagens] = useState([]);

  const [id_motorista, setIdMotorista] = useState(null);
  const [id_veiculo, setIdVeiculo] = useState(null);
  const [id_empresa, setIdEmpresa] = useState(null);
  const [id_cliente, setIdCliente] = useState(null);
  const [dtinicial, setDtInicial] = useState(null);
  const [dtfinal, setDtFinal] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);

        const [motoristasRes, veiculosRes, empresasRes, clientesRes] =
          await Promise.all([
            axios.get('/motoristas'),
            axios.get('/veiculos'),
            axios.get('/empresas'),
            axios.get('/clientes'),
          ]);

        setMotoristas(motoristasRes.data);
        setVeiculos(veiculosRes.data);
        setEmpresas(empresasRes.data);
        setClientes(clientesRes.data);
      } catch (err) {
        const status = get(err, 'response.status', 0);
        const errors = get(err, 'response.data.errors', []);

        if (errors.length > 0) {
          errors.forEach((error) => toast.error(error));
        } else {
          toast.error('Erro inesperado. Tente novamente.');
        }
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  async function fetchAll() {
    let formErrors = true;

    try {
      setIsLoading(true);

      // Construção dinâmica dos parâmetros
      const params = {
        ...(id_empresa && { id_empresa }),
        ...(id_motorista && { id_motorista }),
        ...(id_veiculo && { id_veiculo }),
        ...(id_cliente && { id_cliente }),
        ...(dtinicial && { dtinicial }),
        ...(dtfinal && { dtfinal }),
      };

      // Validação das datas
      if (!dtinicial) {
        toast.error('Informe a Data Inicial');
        formErrors = false;
      }
      if (!dtfinal) {
        toast.error('Informe a Data Final');
        formErrors = false;
      }

      // Requisição apenas se os dados forem válidos
      if (formErrors) {
        const { data } = await axios.get('/viagens/dashMapaProducao', {
          params,
        });
        // Acessa os dados das viagens e dos veículos sem viagens
        const { totalviagens, veiculosSemViagens, qtdePlacas } = data;

        setViagens(totalviagens);
        setVeiculosSemViagens(veiculosSemViagens);
        setQtde(qtdePlacas || 1);
      }
    } catch (err) {
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (errors.length > 0) {
        errors.forEach((error) => toast.error(error));
      } else {
        toast.error('Erro inesperado. Tente novamente.');
      }

      if (status === 401) {
        dispatch(actions.loginFailure());
      }
    } finally {
      setIsLoading(false);
    }
  }

  function limparFiltros() {
    setDtInicial(null);
    setDtFinal(null);
    setIdMotorista(null);
    setIdEmpresa(null);
    setIdCliente(null);
    setIdVeiculo(null);
    setViagens([]);
    setVeiculosSemViagens([]);
  }

  const totalizador = viagens.reduce(
    (acc, viagem) => {
      acc.total_receitas += roundToTwoDecimal(viagem.total_receitas || 0);
      acc.total_despesas += roundToTwoDecimal(viagem.total_despesas || 0);
      acc.km_rodado += roundToTwoDecimal(viagem.km_rodado || 0);
      acc.quantidade_combustivel += roundToTwoDecimal(
        viagem.quantidade_combustivel || 0
      );
      acc.total_comissao += roundToTwoDecimal(viagem.total_comissao || 0);
      acc.lucro += roundToTwoDecimal(viagem.lucro || 0);
      acc.dias_em_viagem += roundToTwoDecimal(viagem.dias_em_viagem || 0);
      acc.km_consumo = roundToTwoDecimal(
        acc.km_rodado / (acc.quantidade_combustivel || 1)
      );
      acc.receita_km = roundToTwoDecimal(
        acc.total_receitas / (acc.km_rodado || 1)
      );
      acc.lucro_km = roundToTwoDecimal(acc.lucro / (acc.km_rodado || 1));
      acc.lucro_bruto = roundToTwoDecimal(
        (acc.total_receitas - acc.total_despesas) / (acc.total_receitas || 1)
      );

      return acc;
    },
    {
      total_receitas: 0,
      total_despesas: 0,
      km_rodado: 0,
      quantidade_combustivel: 0,
      km_consumo: 0,
      total_comissao: 0,
      lucro: 0,
      receita_km: 0,
      lucro_km: 0,
      lucro_bruto: 0,
      dias_em_viagem: 0,
    }
  );

  return (
    <ContainerPainel>
      <Loading isLoading={isLoading} />
      <Title>MAPA DE PRODUÇÃO</Title>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <DatePicker
                required
                label="Data Inicial"
                size="small"
                value={dtinicial}
                onChange={(date) => setDtInicial(date)}
                format="DD/MM/YYYY"
                inputFormat="DD/MM/YYYY"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <DatePicker
                required
                label="Data Final"
                size="small"
                value={dtfinal}
                onChange={(date) => setDtFinal(date)}
                format="DD/MM/YYYY"
                inputFormat="DD/MM/YYYY"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id={id_motorista ? String(id_motorista) : ''}
              value={
                motoristas.find((option) => option.id === id_motorista) || null
              }
              options={motoristas}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setIdMotorista(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Motorista"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id={id_veiculo ? String(id_veiculo) : ''}
              value={
                veiculos.find((option) => option.id === id_veiculo) || null
              }
              options={veiculos}
              getOptionLabel={(option) => option.placa}
              onChange={(event, newValue) => {
                setIdVeiculo(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Veículo"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id={id_empresa ? String(id_empresa) : ''}
              value={
                empresas.find((option) => option.id === id_empresa) || null
              }
              options={empresas}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setIdEmpresa(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Empresa"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id={id_cliente ? String(id_cliente) : ''}
              value={
                clientes.find((option) => option.id === id_cliente) || null
              }
              options={clientes}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setIdCliente(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Cliente"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => fetchAll()}
              style={styles.style11}
            >
              Filtrar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => limparFiltros()}
            >
              Limpar Filtros
            </Button>
          </Grid>
        </Grid>
      </Box>

      <SubTitle
        style={{
          background: colors.cardColor4,
        }}
      >
        Resumo por Veículo
      </SubTitle>

      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
          maxWidth: { xs: '100%', sm: '100%', md: '100%' },
        }}
      >
        <Grid container spacing={2}>
          {viagens.map((viagem, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card
                style={{
                  width: '100%',
                  marginBottom: '10px',
                  border: '1px solid black', // Borda preta
                  color: 'black', // Fonte preta
                  borderRadius: '10px',
                  fontFamily: 'sans-serif',
                  textDecoration: 'none',
                  backgroundColor: '#FFFACD',
                  // backgroundColor: 'transparent', // Sem background color
                }}
              >
                <CardContent>
                  <Typography variant="body2" gutterBottom>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span>Veículo: {viagem.placa}</span>
                      <span>{viagem.nome.split(' ')[0]}</span>
                    </div>
                  </Typography>
                  <Divider
                    style={{
                      backgroundColor: 'black',
                      borderRadius: '10px',
                      marginBottom: '10px',
                    }}
                  />
                  {[
                    {
                      label: 'Receitas (R$)',
                      value: NumberFormat(viagem.total_receitas),
                    },
                    {
                      label: 'KM Rodado (km)',
                      value: NumberFormat(viagem.km_rodado),
                    },
                    {
                      label: 'Diesel (L)',
                      value: NumberFormat(viagem.quantidade_combustivel),
                    },
                    {
                      label: 'Consumo Médio (km/L)',
                      value: NumberFormat(viagem.km_consumo),
                    },
                    {
                      label: 'Comissão (R$)',
                      value: NumberFormat(viagem.total_comissao),
                    },
                    {
                      label: 'Resultado Líquido(R$)',
                      value: NumberFormat(viagem.lucro),
                    },
                    {
                      label: 'Receita/Km (R$)',
                      value: NumberFormat(viagem.receita_km),
                    },
                    {
                      label: 'Líquido/KM (R$)',
                      value: NumberFormat(viagem.lucro_km),
                    },
                    {
                      label: 'Resultado Líquido (%)',
                      value: NumberFormat(viagem.lucro_bruto),
                    },
                    {
                      label: 'Dias em Viagem (Qtde)',
                      value: viagem.dias_em_viagem || 0,
                    },
                    {
                      label: 'Fator Bitrem (R$)',
                      value: NumberFormat(viagem.fatorBitrem),
                    },
                  ].map((item, idx) => (
                    <Typography key={idx} variant="body2">
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <span>{item.label}:</span>
                        <span>{item.value}</span>
                      </div>
                    </Typography>
                  ))}
                </CardContent>
              </Card>
            </Grid>
          ))}
          {viagens.length > 0 && (
            <Grid item xs={12} sm={6} md={3}>
              <Card
                style={{
                  width: '100%',
                  marginBottom: '10px',
                  border: '1px solid black', // Borda preta
                  color: 'black', // Fonte preta
                  borderRadius: '10px',
                  fontFamily: 'sans-serif',
                  textDecoration: 'none',
                  backgroundColor: '#F0F8FF', // Sem background color
                }}
              >
                <CardContent>
                  <Typography variant="body2" gutterBottom>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span>Totalizador</span>
                    </div>
                  </Typography>
                  <Divider
                    style={{
                      backgroundColor: 'black',
                      borderRadius: '10px',
                      marginBottom: '10px',
                    }}
                  />
                  {[
                    {
                      label: 'Receitas (R$)',
                      value: NumberFormat(totalizador.total_receitas),
                    },
                    {
                      label: 'KM Rodado (km)',
                      value: NumberFormat(totalizador.km_rodado),
                    },
                    {
                      label: 'Diesel (L)',
                      value: NumberFormat(totalizador.quantidade_combustivel),
                    },
                    {
                      label: 'Consumo Médio (km/L)',
                      value: NumberFormat(totalizador.km_consumo),
                    },
                    {
                      label: 'Comissão (R$)',
                      value: NumberFormat(totalizador.total_comissao),
                    },
                    {
                      label: 'Resultado Líquido(R$)',
                      value: NumberFormat(totalizador.lucro),
                    },
                    {
                      label: 'Receita/Km (R$)',
                      value: NumberFormat(totalizador.receita_km),
                    },
                    {
                      label: 'Líquido/KM (R$)',
                      value: NumberFormat(totalizador.lucro_km),
                    },
                    {
                      label: 'Resultado Líquido (%)',
                      value: NumberFormat(totalizador.lucro_bruto),
                    },
                    {
                      label: 'Dias em Viagem (Qtde)',
                      value: totalizador.dias_em_viagem || 0,
                    },
                  ].map((item, idx) => (
                    <Typography key={idx} variant="body2">
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <span>{item.label}:</span>
                        <span>{item.value}</span>
                      </div>
                    </Typography>
                  ))}
                </CardContent>
              </Card>
            </Grid>
          )}
          {/* Card de Veículos Sem Viagens */}
          {semViagens.length > 0 && (
            <Grid item xs={12} sm={6} md={3}>
              <Card
                style={{
                  width: '100%',
                  marginBottom: '10px',
                  border: '1px solid black',
                  color: 'black',
                  borderRadius: '10px',
                  fontFamily: 'sans-serif',
                  textDecoration: 'none',
                  backgroundColor: '#F0F8FF',
                }}
              >
                <CardContent>
                  <Typography variant="body2" gutterBottom>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span>Veículos Sem Viagens</span>
                    </div>
                  </Typography>
                  <Divider
                    style={{
                      backgroundColor: 'black',
                      borderRadius: '10px',
                      marginBottom: '10px',
                    }}
                  />
                  {/* Grid para exibir as placas em 10 linhas e colunas dinâmicas */}
                  <Grid container spacing={1}>
                    {Array.from({
                      length: Math.ceil(semViagens.length / 10),
                    }).map((_, colIndex) => (
                      <Grid item key={colIndex} xs>
                        {semViagens
                          .slice(colIndex * 10, (colIndex + 1) * 10) // Divide as placas em grupos de 10
                          .map((placa, rowIndex) => (
                            <Typography
                              key={rowIndex}
                              variant="body2"
                              align="center"
                            >
                              {placa}
                            </Typography>
                          ))}
                      </Grid>
                    ))}
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>
      </Box>

      {viagens.length > 0 && (
        <PDFDownloadLink
          document={
            <PDFContent
              viagens={viagens}
              semViagens={semViagens}
              dtinicial={dtinicial}
              dtfinal={dtfinal}
              totalizador={totalizador}
            />
          }
          fileName="MapaDeProducao.pdf"
          style={{
            textDecoration: 'none',
            padding: '10px',
            color: '#4a4a4a',
            backgroundColor: '#f2f2f2',
            border: '1px solid #4a4a4a',
            borderRadius: '4px',
            marginTop: '20px',
          }}
        >
          {({ blob, url, loading, error }) =>
            loading ? 'Carregando documento...' : 'Baixar PDF'
          }
        </PDFDownloadLink>
      )}
    </ContainerPainel>
  );
}
